import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { campaignsService, Campaign } from '@aslanpay/portal-common-lib';

const useRetryCampaign = (options: UseMutationOptions<Campaign, Error, string>) => {
  return useMutation<Campaign, Error, string>(
    (campaignId) => campaignsService.retryCampaignAnnouncement(campaignId),
    options
  );
};

export default useRetryCampaign;
